<template>
  <layout>
    <loading :active.sync="loading" loader="bars" color="#00ab00"></loading>
    <template v-if="mags.length > 0">
      <transition name="fade">
        <div class="searchresult">
          <div class="resultcard" v-for="mag in mags" :key="mag.miid">
            <div class="left">
              <div @click="navto(mag)" class="title actable">
                {{ mag.mgName }}
                <span class="no">{{ mag.issueNo }}期</span>
              </div>
              <div class="desc">
                {{ mag.title }}
              </div>
              <div class="pd">
                {{ getDate(mag.pubDate) }}
                <span class="lab"> {{ getLcidName(mag.lcid) }}</span>
              </div>
            </div>
            <img :src="mag.cover" class="cover" alt="" />
          </div>
        </div>
      </transition>
    </template>
    <template v-else>
      <transition name="fade">
        <div class="content">
          <img class="logo" src="../assets/logo.png" alt="logo" />
          <div class="cs">
            <span class="iconfont iconsearch"></span>
            <input v-model="searchstr" type="text" @keydown="enter" />
          </div>
        </div>
      </transition>
    </template>
    <template v-slot:ft>
      <mfooter></mfooter>
    </template>
  </layout>
</template>

<script>
import IndexLayout from "./_layout/search_layout";
import Footer from "./Footer";
import { postParams } from "../libs/request";
import { API, lcids } from "../libs/consts";
import * as utils from "../libs/utils";

export default {
  name: "Search",
  components: {
    layout: IndexLayout,
    mfooter: Footer,
  },
  data() {
    return {
      searchstr: this.querystr,
      loading: false,
      pgInd: 1,
      pgLen: 10,
      mags: [],
      maxpages: 1,
    };
  },
  computed: {
    querystr() {
      return this.$route.query.str;
    },
  },
  created() {
    if (this.querystr) {
      this.search();
    }

    window.addEventListener("scroll", this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scroll);
  },
  methods: {
    getDate(num) {
      const d = new Date(num);
      return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
    },
    getLcidName(lcid) {
      const item = lcids.find((x) => x.key == lcid);
      return item ? item.title : "";
    },
    enter(event) {
      console.log(event);
      if (event.code == "Enter") {
        this.$router.push(`/search?str=${encodeURI(this.searchstr)}`);
      }
    },
    navto(mag) {
      sessionStorage.setItem("lcid", mag.lcid);
      this.$router.push(`/read/${mag.brandCode}/${mag.issueId}/${mag.mnId}`);
    },
    search() {
      if (
        this.querystr.length == 0 ||
        this.loading == true ||
        this.pgInd > this.maxpages
      ) {
        return;
      }
      this.loading = true;
      postParams(API.magz.search, {
        type: "magz",
        keywords: this.querystr,
        pgInd: this.pgInd,
        pgLen: this.pgLen,
      })
        .then((rps) => {
          if (rps.errMsg == API.Code.ok) {
            if (rps.data.list) {
              this.mags.push(...rps.data.list);
              this.pgInd++;
              this.maxpages = rps.data.pageTotal;
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    scroll() {
      //window 1%的误差
      console.log("scroll");
      if (
        utils.scrollFix(utils.getScrollHeight()) ==
        utils.scrollFix(utils.getWindowHeight() + utils.getDocumentTop())
      ) {
        this.search();
      }
    },
  },
  watch: {
    querystr() {
      this.pgInd = 1;
      this.mags = [];
      this.maxpages = 1;
      this.search();
    },
  },
};
</script>

<style scoped>
.logo {
  width: 2.2rem;
  height: 0.9rem;
}
.cs {
  position: relative;
  margin: 0 auto;
  margin-top: 0.2rem;
}

.cs input:focus {
  border-color: #409eff;
}

.cs input {
  height: 0.5rem;
  width: 6rem;
  height: 0.5rem;
  line-height: 0.4rem;
  border: 2px solid #848484;
  padding: 0.1rem 0.6rem;
  outline: none;
  border-radius: 0.5rem;
  font-size: 0.26rem;
  width: 5.8rem;
}
.iconsearch {
  font-size: 0.3rem;
  color: #777777;
  position: absolute;
  top: 0.2rem;
  left: 0.3rem;
}

.content {
  margin-top: 1.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.searchresult {
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: flex-start;
}

.resultcard {
  width: 12rem;
  height: 2rem;
  position: relative;
  border-bottom: 1px solid #979797;
}

.left {
  padding: 0.16rem 0 0.16rem 0.36rem;
}

.cover {
  width: 2.34rem;
  height: 1.64rem;
  /* height: calc(100vh -1.6rem); */
  position: absolute;
  right: 0.28rem;
  top: 0.17rem;
}

.desc,
.title {
  font-size: 0.25rem;
  line-height: 0.4rem;
  max-width: 8.8rem;
  color: #474747;
}

.no {
  color: #125faf;
  padding: 0 0.08rem;
}

.pd {
  position: absolute;
  bottom: 0.17rem;
  font-size: 0.22rem;
  color: #ababab;
}

.lab {
  padding: 0.08rem 0.12rem;
  background-color: #eaeaea;
  color: #474747;
  margin-left: 0.18rem;
}
</style>